import { useEffect, useState } from "react";
import { fetchController } from "../../utils/FetchController/fetchController";
import { getHostDomain } from "../../utils/utils";

export default function useMonthlyUsages() {
  const baseUrl = getHostDomain();
  const [monthlyUsages, setMonthlyUsages] = useState([]);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    (async () => {
      setStatus("loading");
      try {
        const res = await fetchController(
          `${baseUrl}/api/v1/user_usage/user_monthly_usages?size=12`,
          "GET"
        );
        setMonthlyUsages(res?.data?.items || []);
      } catch {
        setMonthlyUsages([]);
      } finally {
        setStatus("idle");
      }
    })();
  }, [baseUrl]);

  return { monthlyUsages, status };
}
